import moment from 'moment';

// Kontenjan boslugu analizi.
//
// Kaynak: /property/rooms-inventory/get (getPropertyInventory) — Kontenjan ekraninin
// kullandigi ucun aynisi. channel_id = 1 (Booking Engine): siteden gelen rezervasyonlar
// bu kanaldan gectigi icin "sitede satilamayan tarih" bu kanalin kontenjanina bakar.
//
// Yanit sekli:
//   [{ id, name, room_availability: { "2026-08-19": {key, value, stop_sell}, ... }, ... }]
//
// Bir tarih su iki durumda satilamaz sayilir:
//   - value 0 / bos      -> kontenjan girilmemis  (reason: 'zero')
//   - stop_sell dolu     -> satisa kapatilmis     (reason: 'closed')

const isEmptyAvailability = (entry) => {
    if (!entry) return true;
    const value = entry.value;
    if (value === null || value === undefined || value === '') return true;
    return Number(value) <= 0;
};

const isStopSell = (entry) => !!(entry && (entry.stop_sell === true || Number(entry.stop_sell) === 1));

// Ardisik gunleri tek aralikta toplar; sebep degisirse yeni aralik acar.
const groupRanges = (days) => {
    const ranges = [];
    let current = null;

    days.forEach((day) => {
        const previousDate = current && current.to;
        // Gun farki moment ile alinir: ham ms cikarmasi yaz saati gecislerinde sasar
        const isConsecutive = previousDate
            && moment(day.date, 'YYYY-MM-DD').diff(moment(previousDate, 'YYYY-MM-DD'), 'days') === 1;

        if (current && isConsecutive && current.reason === day.reason) {
            current.to = day.date;
            current.days += 1;
            return;
        }

        if (current) ranges.push(current);
        current = {from: day.date, to: day.date, days: 1, reason: day.reason};
    });

    if (current) ranges.push(current);
    return ranges;
};

export function buildInventoryGaps(inventory) {
    if (!Array.isArray(inventory) || inventory.length === 0) return [];

    return inventory.map((room) => {
        const availability = (room && room.room_availability) || {};
        const dates = Object.keys(availability).sort();

        const emptyDays = [];
        dates.forEach((date) => {
            const entry = availability[date];
            if (isStopSell(entry)) {
                emptyDays.push({date, reason: 'closed'});
            } else if (isEmptyAvailability(entry)) {
                emptyDays.push({date, reason: 'zero'});
            }
        });

        return {
            roomId: room.id,
            roomName: room.name,
            totalDays: dates.length,
            emptyDays: emptyDays.length,
            ranges: groupRanges(emptyDays),
        };
    });
}

// --- Tarih bicimleme ---------------------------------------------------------
// Servisten tarihler YYYY-MM-DD geliyor; ekranda Turkiye bicimiyle (GG/AA/YYYY) yazilir.

const DISPLAY_FORMAT = 'DD/MM/YYYY';

export function formatDate(isoDate) {
    if (!isoDate) return '';
    const date = moment(isoDate, 'YYYY-MM-DD');
    return date.isValid() ? date.format(DISPLAY_FORMAT) : String(isoDate);
}

/**
 * "19/08/2026 – 26/08/2026"  (aralik)
 * "19/08/2026"               (tek gun)
 */
export function formatDateRange(fromIso, toIso) {
    if (!fromIso && !toIso) return '';
    if (!toIso || fromIso === toIso) return formatDate(fromIso);
    return `${formatDate(fromIso)} – ${formatDate(toIso)}`;
}

export default buildInventoryGaps;
